import "bootstrap/dist/css/bootstrap.min.css"
import React, { useEffect } from "react"
import { initializeActivityTracking, getToken } from "./api/AuthService"
import { createRoot } from "react-dom/client"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { getWebInstrumentations, initializeFaro, faro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import APMPAllInfo from "./components/apmpComponents/ApmpAllInfo"
import APPAllInfo from "./components/appComponents/AppAllInfo"
import ARMPAllInfo from "./components/armpComponents/ArmpAllInfo"
import ASLAllInfo from "./components/aslComponents/AslAllInfo"
import BsfAllInfo from "./components/bsfComponents/BsfAllInfo"
import CDBAllInfo from "./components/cdbComponents/CdbAllInfo"
import CmnAllInfo from "./components/cmnComponents/CmnAllInfo"
import COMIRMInfo from "./components/commonPage/ComIRMAllInfo"
import CommonPage from "./components/commonPage/ComPageAllInfo"
import CopAllInfo from "./components/copComponents/CopAllInfo"
import CopyListAllInfo from "./components/copListComponents/CopyListAllInfo"
import CupAllInfo from "./components/cupComponents/CupAllInfo"
import DPPAllInfo from "./components/dppComponents/DppAllInfo"
import GenReport from "./components/dynamicReports/GenReport"
import ReportDetails from "./components/dynamicReports/ReportDetails"
import ReportInfo from "./components/dynamicReports/ReportInfo"
import TemplateInfo from "./components/dynamicReports/TemplateSummary/TemplateInfo"
import DynamicSub from "./components/dynamicSubscription/CreateDynamicSub"
import DynamicSubscription from "./components/dynamicSubscription/DynamicSubscription"
import SubscriptionDetails from "./components/dynamicSubscription/SubscriptionDetails"
import EmpAllInfo from "./components/empComponents/EmpAllInfo"
import FABAllInfo from "./components/fabComponents/FabAllInfo"
import FcAllInfo from "./components/fcComponents/FcAllInfo"
import FopAllInfo from "./components/fopComponents/FopAllInfo"
import FppAllInfo from "./components/fppComponents/FppAllInfo"
import GCASRoute from "./components/GCASComponents/GCASRoute"
import IMPAllInfo from "./components/impComponents/ImpAllInfo"
import IpAllInfo from "./components/ipComponents/IpAllInfo"
import IPPAllInfo from "./components/ippComponents/IppAllInfo"
import IRMSAllInfo from "./components/irmsComponents/IrmsAllInfo"
import AppLogout from "./components/login/AppLogout"
import Login from "./components/login/Login"
import Redirect from "./components/login/Redirect"
import MCOPAllInfo from "./components/mcopComponents/McopAllInfo"
import MCPAllInfo from "./components/mcpComponents/McpAllInfo"
import MCUPAllInfo from "./components/mcupComponents/McupAllInfo"
import MEPAllInfo from "./components/mepComponents/MepAllInfo"
import MIPAllInfo from "./components/mipComponents/MipAllInfo"
import MPAPAllInfo from "./components/mpapComponents/MpapAllInfo"
import MPMPAllInfo from "./components/mpmpComponents/MpmpAllInfo"
import MPPAllInfo from "./components/mppComponents/MppAllInfo"
import MpsAllInfo from "./components/mpsComponents/MpsAllInfo"
import MRMPAllInfo from "./components/mrmpComponents/MrmpAllInfo"
import NotAccess from "./components/NotAcess"
import OPPAllInfo from "./components/oppComponents/OppAllInfo"
import PageNotFound from "./components/PageNotFound"
import PAPAllInfo from "./components/papComponents/PapAllInfo"
import PIPAllInfo from "./components/pipComponents/PipAllInfo"
import PmpAllInfo from "./components/pmpComponents/PmpAllInfo"
import POAAllInfo from "./components/poaComponents/PoaAllInfo"
import PQRInfo from "./components/pqrComponents/PqrAllInfo"
import PsubAllInfo from "./components/psubComponents/PsubAllInfo"
import RmpAllInfo from "./components/rmpComponents/RmpAllInfo"
import SbvAllInfo from "./components/sbvComponents/SbvAllInfo"
import SearchComponent from "./components/search/SearchComponent"
import SearchFromHeader from "./components/search/SearchFromHeader"
import SEPAllInfo from "./components/sepComponents/SepAllInfo"
import ServiceUnavailable from "./components/ServiceUnavailable"
import SisAllInfo from "./components/sisComponents/SisAllInfo"
import SmlAllInfo from "./components/smlComponents/SmlAllInfo"
import SwpAllInfo from "./components/swpComponents/SwpAllInfo"
import TupAllInfo from "./components/tupComponents/TupAllInfo"
import VendorInfo from "./components/vendorInfo/VendorInfo"
import PartComparison from "./components/partComparison/PartComparison"
import NewUpdates from "./components/commonComponents/NewUpdates"
import Downloadpdf from "./components/downloadComponents/Downloadpdf"
import PreliminaryRouter from "./components/commonPage/PreliminaryRouter"
import UnreleasedSearchPage from "./components/search/UnreleasedSearchPage"
import "./index.css"

if (process.env.REACT_APP_FARO_URL) initializeFaro({
  url: process.env.REACT_APP_FARO_URL,
  app: {
    // Keep name same for both as requested
    name: (process.env.REACT_APP_CUSTOM_NODE_ENV === 'SIT' || process.env.REACT_APP_CUSTOM_NODE_ENV === 'QA' || process.env.REACT_APP_CUSTOM_NODE_ENV === 'PROD') 
      ? 'Specreader-UI' 
      : 'sdev-ui',
    version: '1.0.0',
    environment: process.env.REACT_APP_CUSTOM_NODE_ENV === 'SIT' 
      ? 'SIT' 
      : process.env.REACT_APP_CUSTOM_NODE_ENV === 'QA' 
        ? 'QA'
        : process.env.REACT_APP_CUSTOM_NODE_ENV === 'PROD'
          ? 'PROD'         
          : 'SDEV',
  },    
  instrumentations: [
    ...getWebInstrumentations({ captureConsole: true }),
    new TracingInstrumentation({
      resourceAttributes: {
        // Service Name identical for both SIT and QA
        'service.name': (process.env.REACT_APP_CUSTOM_NODE_ENV === 'SIT' || process.env.REACT_APP_CUSTOM_NODE_ENV === 'QA' || process.env.REACT_APP_CUSTOM_NODE_ENV === 'PROD') 
          ? 'Specreader-UI' 
          : 'sdev-ui',
        'service.version': '1.0.0',
        'deployment.environment': process.env.REACT_APP_CUSTOM_NODE_ENV === 'SIT' 
          ? 'SIT' 
          : process.env.REACT_APP_CUSTOM_NODE_ENV === 'QA' 
            ? 'QA' 
            : process.env.REACT_APP_CUSTOM_NODE_ENV === 'PROD'
              ? 'PROD'         
              : 'SDEV',
        'application_id': 'CI001910132',
        'cost_center': '8000500111',
      },
      instrumentationOptions: {
        propagateTraceHeaderCorsUrls: [
          new RegExp('https://specsdevs\\.pg\\.com:8443/.*'),
          new RegExp('https://specssit\\.pg\\.com:443/.*'),
          new RegExp('https://specsqa\\.pg\\.com:443/.*'),
          new RegExp('https://specreader\\.pg\\.com:443/.*'),        
        ],
      },
    }),
  ],
});
 

// If the user already has a valid session (e.g. page refresh), push their identity
// into Faro immediately so all traces carry the userId from the first span.
const _startupUserId = localStorage.getItem('UserId');
if (_startupUserId && faro?.api) {
  faro.api.setUser({
    id: _startupUserId,
    attributes: {
      userType: localStorage.getItem('userType') || 'unknown',
      role: localStorage.getItem('role') || 'unknown',
    },
  });
}

// Error Boundary Component
class ErrorBoundary extends React.Component {
   constructor(props) {
      super(props)
      this.state = { hasError: false, error: null, errorInfo: null }
   }

   static getDerivedStateFromError(error) {
      return { hasError: true }
   }

   componentDidCatch(error, errorInfo) {
      console.error("❌ ErrorBoundary caught error:", error)
      console.error("❌ Error Info:", errorInfo)
      console.error("❌ Component Stack:", errorInfo.componentStack)
      this.setState({ error, errorInfo })
   }

   render() {
      if (this.state.hasError) {
         return (
            <div style={{ padding: "20px", background: "#ffebee", color: "#c62828", fontFamily: "monospace" }}>
               <h1>⚠️ Component Rendering Error</h1>
               <h2>Error: {this.state.error?.toString()}</h2>
               <details style={{ whiteSpace: "pre-wrap", marginTop: "20px", background: "white", padding: "10px" }}>
                  <summary style={{ cursor: "pointer", fontWeight: "bold" }}>Click to see Component Stack Trace</summary>
                  <pre>{this.state.errorInfo?.componentStack}</pre>
               </details>
               <button 
                  onClick={() => window.location.href = "/"} 
                  style={{ marginTop: "20px", padding: "10px 20px", cursor: "pointer" }}
               >
                  Go to Home
               </button>
            </div>
         )
      }

      return this.props.children
   }
}

function RouterSettings() {
   return (
      <Router>
         <Routes>
            <Route path="/" element={<ErrorBoundary><Redirect /></ErrorBoundary>} />
            <Route path="/login" element={<ErrorBoundary><Login /></ErrorBoundary>} />
            <Route path="/logout" element={<ErrorBoundary><AppLogout /></ErrorBoundary>} />
            <Route path="/search/" element={<ErrorBoundary><SearchComponent /></ErrorBoundary>} />
            <Route
               path="/search/:searchText/:searchType"
               element={<ErrorBoundary><SearchFromHeader /></ErrorBoundary>}
            />
            <Route path="/GCAS/:objectID" element={<ErrorBoundary><GCASRoute /></ErrorBoundary>} />
            <Route path="/FPP/:objectID" element={<ErrorBoundary><FppAllInfo /></ErrorBoundary>} />
            <Route path="/CUP/:objectID" element={<ErrorBoundary><CupAllInfo /></ErrorBoundary>} />
            <Route path="/COP/:objectID" element={<ErrorBoundary><CopAllInfo /></ErrorBoundary>} />
            <Route path="/CMA/:objectID" element={<ErrorBoundary><CmnAllInfo /></ErrorBoundary>} />
            <Route path="/RMP/:objectID" element={<ErrorBoundary><RmpAllInfo /></ErrorBoundary>} />
            <Route path="/FOP/:objectID" element={<ErrorBoundary><FopAllInfo /></ErrorBoundary>} />
            <Route path="/PMP/:objectID" element={<ErrorBoundary><PmpAllInfo /></ErrorBoundary>} />
            <Route path="/IP/:objectID" element={<ErrorBoundary><IpAllInfo /></ErrorBoundary>} />
            <Route path="/TUP/:objectID" element={<ErrorBoundary><TupAllInfo /></ErrorBoundary>} />
            <Route path="/APP/:objectID" element={<ErrorBoundary><APPAllInfo /></ErrorBoundary>} />
            <Route path="/PAP/:objectID" element={<ErrorBoundary><PAPAllInfo /></ErrorBoundary>} />
            <Route path="/MPAP/:objectID" element={<ErrorBoundary><MPAPAllInfo /></ErrorBoundary>} />
            <Route path="/APMP/:objectID" element={<ErrorBoundary><APMPAllInfo /></ErrorBoundary>} />
            <Route path="/IPP/:objectID" element={<ErrorBoundary><IPPAllInfo /></ErrorBoundary>} />
            <Route path="/MIP/:objectID" element={<ErrorBoundary><MIPAllInfo /></ErrorBoundary>} />
            <Route path="/MCOP/:objectID" element={<ErrorBoundary><MCOPAllInfo /></ErrorBoundary>} />
            <Route path="/MCUP/:objectID" element={<ErrorBoundary><MCUPAllInfo /></ErrorBoundary>} />
            <Route path="/CDB/:objectID" element={<ErrorBoundary><CDBAllInfo /></ErrorBoundary>} />
            <Route path="/ASL/:objectID" element={<ErrorBoundary><ASLAllInfo /></ErrorBoundary>} />
            <Route path="/PIP/:objectID" element={<ErrorBoundary><PIPAllInfo /></ErrorBoundary>} />
            <Route path="/OPP/:objectID" element={<ErrorBoundary><OPPAllInfo /></ErrorBoundary>} />
            <Route path="/FAB/:objectID" element={<ErrorBoundary><FABAllInfo /></ErrorBoundary>} />
            <Route path="/IRMS/:objectID" element={<ErrorBoundary><IRMSAllInfo /></ErrorBoundary>} />
            <Route path="/MRMP/:objectID" element={<ErrorBoundary><MRMPAllInfo /></ErrorBoundary>} />
            <Route path="/MPP/:objectID" element={<ErrorBoundary><MPPAllInfo /></ErrorBoundary>} />
            <Route path="/MPMP/:objectID" element={<ErrorBoundary><MPMPAllInfo /></ErrorBoundary>} />
            <Route path="/DPP/:objectID" element={<ErrorBoundary><DPPAllInfo /></ErrorBoundary>} />
            <Route path="/COM/IRM/:objectID" element={<ErrorBoundary><COMIRMInfo /></ErrorBoundary>} />
            <Route path="/COM/IRM/:objectID/:partName" element={<ErrorBoundary><COMIRMInfo /></ErrorBoundary>} />
            <Route path="/COM/SPS/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/SPS/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/TMS/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/TMS/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/IPM/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/IPM/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/ACS/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/ACS/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/ATS/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/ATS/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/ILST/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/ILST/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/IAPS/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/IAPS/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/LIS/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/LIS/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/MI/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/MI/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/PI/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/PI/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/PROS/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/PROS/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/SP/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/SP/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/SOP/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/SOP/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/RMPI/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/RMPI/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/QUAL/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/QUAL/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/CPP/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/CPP/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/ARTCAD/:objectID" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/COM/ARTCAD/:objectID/:partName" element={<ErrorBoundary><CommonPage /></ErrorBoundary>} />
            <Route path="/MEP/:objectID" element={<ErrorBoundary><MEPAllInfo /></ErrorBoundary>} />
            <Route path="/SEP/:objectID" element={<ErrorBoundary><SEPAllInfo /></ErrorBoundary>} />
            <Route path="/POA/:objectID" element={<ErrorBoundary><POAAllInfo /></ErrorBoundary>} />
            <Route path="/ARMP/:objectID" element={<ErrorBoundary><ARMPAllInfo /></ErrorBoundary>} />
            <Route path="/IMP/:objectID" element={<ErrorBoundary><IMPAllInfo /></ErrorBoundary>} />
            <Route path="/MCP/:objectID" element={<ErrorBoundary><MCPAllInfo /></ErrorBoundary>} />
            <Route path="/PSUB/:objectID" element={<ErrorBoundary><PsubAllInfo /></ErrorBoundary>} />
            <Route path="/FC/:objectID" element={<ErrorBoundary><FcAllInfo /></ErrorBoundary>} />
            <Route path="/MPS/:objectID" element={<ErrorBoundary><MpsAllInfo /></ErrorBoundary>} />
            <Route path="/vendorInfo/" element={<ErrorBoundary><VendorInfo /></ErrorBoundary>} />
            <Route path="/PQR/:objectID" element={<ErrorBoundary><PQRInfo /></ErrorBoundary>} />
            <Route path="/SIS/:objectID" element={<ErrorBoundary><SisAllInfo /></ErrorBoundary>} />
            <Route path="/BSF/:objectID" element={<ErrorBoundary><BsfAllInfo /></ErrorBoundary>} />
            <Route path="/SWP/:objectID" element={<ErrorBoundary><SwpAllInfo /></ErrorBoundary>} />
            <Route path="/SML/:objectID" element={<ErrorBoundary><SmlAllInfo /></ErrorBoundary>} />
            <Route path="/SBV/:objectID" element={<ErrorBoundary><SbvAllInfo /></ErrorBoundary>} />
            <Route path="/CL/:objectID" element={<ErrorBoundary><CopyListAllInfo /></ErrorBoundary>} />
            <Route path="/EMP/:objectID" element={<ErrorBoundary><EmpAllInfo /></ErrorBoundary>} />
            <Route path="/DsmReport/" element={<ErrorBoundary><ReportInfo /></ErrorBoundary>} />
            <Route path="/UserManuals/" element={<ErrorBoundary><NewUpdates /></ErrorBoundary>} />
            <Route path="/Subscription/" element={<ErrorBoundary><DynamicSubscription /></ErrorBoundary>} />
            <Route
               path="/SubscriptionDetails/:objectID"
               element={<ErrorBoundary><SubscriptionDetails /></ErrorBoundary>}
            />
            <Route path="/GenReport/" element={<ErrorBoundary><GenReport /></ErrorBoundary>} />
            <Route path="/Templates/" element={<ErrorBoundary><TemplateInfo /></ErrorBoundary>} />
            <Route path="/ReportDetail/:objectID" element={<ErrorBoundary><ReportDetails /></ErrorBoundary>} />
            <Route path="/DynamicSubscription/" element={<ErrorBoundary><DynamicSub /></ErrorBoundary>} />
            <Route path="/DynamicSubscription/:searchID" element={<ErrorBoundary><DynamicSub /></ErrorBoundary>} />
            <Route path="/PartComparison/" element={<ErrorBoundary><PartComparison /></ErrorBoundary>} />
            <Route path="/serviceNotFound/:errorCode" element={<ErrorBoundary><ServiceUnavailable /></ErrorBoundary>} />
            <Route path="/NotAccess" element={<ErrorBoundary><NotAccess /></ErrorBoundary>} />
            <Route path="/PDF/download/pdf/:Name" element={<ErrorBoundary><Downloadpdf /></ErrorBoundary>} />
            <Route path="/PDF/download/gendoc/:Name" element={<ErrorBoundary><Downloadpdf /></ErrorBoundary>} />
            <Route path="/unreleasedData/:partName" element={<ErrorBoundary><UnreleasedSearchPage /></ErrorBoundary>} />
            <Route path="/preliminary/COM/:subType/:objectID/:partName" element={<ErrorBoundary><PreliminaryRouter /></ErrorBoundary>} />
            <Route path="/preliminary/:type/:searchId/:partName" element={<ErrorBoundary><PreliminaryRouter /></ErrorBoundary>} />
            <Route path="/:objectID" element={<ErrorBoundary><GCASRoute /></ErrorBoundary>} />
            <Route path="*" element={<ErrorBoundary><PageNotFound /></ErrorBoundary>} />
         </Routes>
      </Router>
   )
}

function App() {
   useEffect(() => {
      // Only initialize if user is already logged in
      const token = getToken()
      if (token && token !== "undefined") {
         initializeActivityTracking()
      }

      // Cleanup on unmount
      return () => {
         if (window.removeActivityListeners) {
            window.removeActivityListeners()
         }
      }
   }, [])

   return <RouterSettings />
}

const rootElement = document.getElementById("root")
const root = createRoot(rootElement)

root.render(<App />)

